/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SignInOAuthCallbackParams = zod.object({
	code: zod.string().optional(),
	state: zod.string().optional()
});

export type SignInOAuthCallbackParams = zod.input<typeof SignInOAuthCallbackParams>;
export type SignInOAuthCallbackParamsOutput = zod.output<typeof SignInOAuthCallbackParams>;
